import {
  ReadOnlyField,
  unsafeLocalizedString,
} from "@dbn/omnichannel-design-system-g4p";
import { ComponentProps } from "react";
import { NumberField } from "./NumberField";
import { ReadOnlyFieldToValue } from "../ReadOnlyField/ReadOnlyFieldToValue";
import { constant, pipe } from "fp-ts/function";
import { option } from "fp-ts";

type Feedback = ComponentProps<typeof ReadOnlyField>["feedback"];

type Props = ComponentProps<typeof NumberField> & {
  feedback?: Feedback;
};

export function NumberFieldOrReadonly(props: Props) {
  return props.disabled ? (
    <ReadOnlyFieldToValue
      size="medium"
      value={pipe(
        props.value,
        option.map(val => "" + val),
        option.map(val =>
          option.isSome(props.rightContent)
            ? val + " " + props.rightContent.value
            : val
        ),
        option.getOrElse(constant(""))
      )}
      label={props.label ?? unsafeLocalizedString("")}
      feedback={props.feedback}
    />
  ) : (
    <NumberField {...props} />
  );
}
